/* src/app/auth/components/recover-page/recover-page.component.scss */
.left-text {
  max-width: 400px;
}
.back-link {
  line-height: 26px;
}
/*# sourceMappingURL=recover-page.component.css.map */
